import { useState } from "react";
import SubMenuSpecialItem from "./SubMenuSpecialItem";
import styles from "./subMenuSpecial.module.scss";
import { Icon, Drawer } from "@monta/design-system";
import type { IMenu } from "../../../../../../constants";

interface SubMenuSpecialProps {
  items: IMenu[];
  onCloseDrawer: () => void;
}

const SubMenuSpecial = (props: SubMenuSpecialProps) => {
  const { items, onCloseDrawer } = props;
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedItem, setSelectedItem] = useState<IMenu>();

  return (
    <div className={styles["sub-menu"]} id="SubMenuSpecialmobile">
      <ul>
        {items?.map((item) => (
          <li key={item.linkID}>
            <SubMenuSpecialItem
              item={item}
              isLink={true}
              onClick={() => {
                setSelectedItem(item);
              }}
              onClickIcon={() => {
                setOpenDrawer(true);
              }}
              onCloseDrawer={onCloseDrawer}
            />
          </li>
        ))}
      </ul>
      <Drawer open={openDrawer} onclose={() => setOpenDrawer(!openDrawer)}>
        <div className={styles["drawer__header"]}>
          <Icon
            icon={"mi-Wrong-answer"}
            size={1.12}
            onClick={() => {
              onCloseDrawer && onCloseDrawer();
              setOpenDrawer(!openDrawer);
              setSelectedItem(undefined);
            }}
          />
        </div>
        <div>
          <div className={styles["drawer__title"]}>
            <Icon
              icon={"mi-Arrow-Right"}
              size={1.3}
              onClick={() => setOpenDrawer(!openDrawer)}
            />
            {selectedItem?.title}
          </div>
          <ul>
            {selectedItem?.childs?.linkList.map((item) => (
              <li key={item.linkID}>
                <SubMenuSpecialItem
                  item={item}
                  isLink={true}
                  onCloseDrawer={onCloseDrawer}
                />
              </li>
            ))}
          </ul>
        </div>
      </Drawer>
    </div>
  );
};

export default SubMenuSpecial;
